<div class="longStringWrapper">
  <ng-container
    *ngIf="rowData?.length <= truncateLength; else showTruncatedString"
  >
    {{ rowData || 'N/A' }}
  </ng-container>

  <ng-template #showTruncatedString>
    <span
      *ngIf="
        ['string', 'boolean']?.includes(typeOfRowData);
        else showPlaceholder
      "
      [nbTooltip]="rowData"
    >
      <span *ngIf="typeOfRowData === 'string'">
        {{ rowData?.substring(0, eachSubstringLength) }}...{{
          rowData?.substring(
            rowData?.length - eachSubstringLength,
            rowData?.length
          )
        }}
      </span>
      <span *ngIf="typeOfRowData === 'boolean'">
        {{ rowData }}
      </span>
    </span>
    <ng-template #showPlaceholder>
      <span>-</span>
    </ng-template>
  </ng-template>
</div>
